module.exports = __webpack_public_path__ + "static/workstation-fc03da7be6b4790e4de8486c5d98fbfb.jpg";